import $ from "jquery";
import "jquery.cookie";

const csrftoken = $.cookie("csrftoken");

$.ajaxSetup({
  beforeSend(xhr, settings) {
    xhr.setRequestHeader("API-TOKEN", "1c2850ea-6259-4e7b-b9c0-73a421c5f939");
    if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && !this.crossDomain) {
      return xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
  },
});
